import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-ai-agent-2 }}\n{{outlet}}",{ moduleName: "embercom/templates/apps/app/standalone/procedures.hbs" })